import { BacktestingScoreBreakdown } from "@shared/types";
import { getRiskValue } from "@shared/features/newMarketplace/utils";
import { useMemo } from "react";
import { useTheme } from "styled-components";
import { RiskType } from "@shared/features/newMarketplace/types";
import { RISK_TYPE_TO_PERCENT_RANGE } from "@shared/features/newMarketplace/constants";

interface useRiskChartProps {
  scoreBreakdown: BacktestingScoreBreakdown;
}

const useRiskChart = ({ scoreBreakdown }: useRiskChartProps) => {
  const theme = useTheme();

  const riskValue = useMemo(
    () => getRiskValue(scoreBreakdown),
    [scoreBreakdown]
  );

  const riskType = useMemo(
    () =>
      Object.values(RiskType).find((riskType) => {
        const percentRange = RISK_TYPE_TO_PERCENT_RANGE[riskType];
        if (riskValue > percentRange[0] && riskValue < percentRange[1])
          return riskType;
      }),
    [riskValue]
  );

  const chartData = useMemo(
    () =>
      Object.values(RiskType).map((riskType) => ({
        value: 12.5,
        name: riskType,
        color: RISK_TYPE_TO_COLOR[riskType],
      })),
    []
  );

  const riskTypeColor = riskType ? RISK_TYPE_TO_COLOR[riskType] : undefined;

  return {
    chartData,
    riskType,
    riskValue,
    riskTextColor: riskTypeColor ?? theme.colors.primaryText,
    riskTypeColor,
  };
};

export default useRiskChart;

const RISK_TYPE_TO_COLOR = {
  [RiskType.LOW]: "#14CB17",
  [RiskType.MEDIUM]: "#FEB932",
  [RiskType.HIGH]: "#FD6157",
  [RiskType.VERY_HIGH]: "#C82116",
};
